import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { AgreementCell } from '../../common/datagrid';
import { AgNumberCellRenderer } from '../../common/datagrid/components/AgNumberCellRenderer';
import { PriceChangeDirection, PriceDto } from '../../common/PricePrgClient';

export type PriceRow = {
    productId: number;
    productName: string;
    customProductAttribute1: string;
    unit: string;
    country: string;
    purchaser: string;
    stock: number | null;
    netWeight: number;
    [pricelistId: number]: number;
    boxesPerPallet: number;
    customerPriceChangeDirections: {
        [pricelistId: number]: PriceChangeDirection | undefined;
    };
    updatedBys: {
        [pricelistId: number]: string;
    };
    updatedDates: {
        [pricelistId: number]: Date;
    };
    priceIds: {
        [pricelistId: number]: number;
    };
    comments: {
        [pricelistId: number]: string;
    };
    saves: {
        [pricelistId: number]: number;
    };
    basePrices: {
        [pricelistId: number]: number;
    },
    exchangeRates: {
        [pricelistId: number]: number;
    },
    agreementPriceIds: number[];
    appliedCalculations: number[];
};

export type Price = PriceDto & {
    priceToBeSaved?: number;
};

export const priceInitialColumns: ColDef<PriceRow>[] = [
    {
        field: 'productId',
        headerName: 'Product id',
        width: 100,
        editable: false,
        cellRenderer: ({ data: row }: ICellRendererParams<PriceRow>) =>
            AgreementCell({
                value: String(row?.productId),
                agreementPriceIds: row?.agreementPriceIds ?? [],
                priceType: 'in'
            })
    },
    {
        field: 'productName',
        headerName: 'Product name',
        width: 300,
        editable: false
    },
    {
        field: 'customProductAttribute1',
        headerName: 'EMV',
        editable: false,
        width: 60
    },
    {
        field: 'netWeight',
        headerName: 'Net Weight',
        width: 90,
        editable: false,
        cellRenderer: AgNumberCellRenderer
    },
    {
        field: 'unit',
        headerName: 'Unit',
        editable: false,
        width: 80
    },
    {
        field: 'country',
        headerName: 'Country',
        editable: false,
        width: 82
    },
    {
        field: 'purchaser',
        headerName: 'Purchaser',
        editable: false,
        width: 120
    },
    {
        field: 'stock',
        headerName: 'Stock',
        width: 80,
        editable: false,
        cellRenderer: AgNumberCellRenderer
    },
    {
        field: 'boxesPerPallet',
        headerName: 'Boxes per pallet',
        width: 80,
        editable: false,
        cellRenderer: AgNumberCellRenderer
    }
];
